export default __webpack_public_path__ + "static/media/Moxa_IMG.05805bab.png";